import React from "react";
import Particles from "react-particles-js";

const AnimatedBackground = () => {
  return (
    <>
      <Particles
        params={{
          particles: {
            number: {
              value: 30,
              density: {
                enable: true,
                value_area: 900,
              },
            },
            shape: {
              type: "circle",
              stroke: {
                width: 6,
                color: "#DC143C",
              },
            },
          },
            interactivity: {
              events: {
                onhover: {
                  enable: true,
                  mode: "repulse",
                },
              },
            },
        }}
      />
    </>
  );
};

export default AnimatedBackground;
